import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateSupportTicketInput, SupportTicketListQuery } from '@teentack/shared';
import { createTicket, fetchHelp, fetchMyTickets } from './support.api';

export const supportKeys = {
  all: ['support'] as const,
  help: ['support', 'help'] as const,
  tickets: (query: Partial<SupportTicketListQuery>) => ['support', 'tickets', query] as const,
};

/** The articles rarely change, so they are cached for the session. */
export function useHelp() {
  return useQuery({
    queryKey: supportKeys.help,
    queryFn: fetchHelp,
    staleTime: 10 * 60_000,
  });
}

export function useMyTickets(query: Partial<SupportTicketListQuery> = {}, enabled = true) {
  return useQuery({
    queryKey: supportKeys.tickets(query),
    queryFn: () => fetchMyTickets(query),
    enabled,
  });
}

export function useCreateTicket() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateSupportTicketInput) => createTicket(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: supportKeys.all });
      void queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}
